(function () {
  'use strict';
  var PX = 'hw';
  function T() { return window.Theme; }
  function words() { var el = document.getElementById(PX + '-ui-strings'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) { try { return T().money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function pic(src, w) {
    if (!src) return '<span class="' + PX + '-ui__ph" aria-hidden="true"></span>';
    var u = /^data:/.test(src) ? src : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w * 2);
    return '<img src="' + esc(u) + '" alt="" width="' + w + '" height="' + w + '" loading="lazy">';
  }
  function count(n, W) { return n + ' ' + (n === 1 ? (W.item_one || 'item') : (W.item_other || 'items')); }
  function cartUrl() { return (T() && T().routes && T().routes.cart) || '/cart'; }
  function checkoutUrl() { return (T() && T().routes && T().routes.checkout) || '/checkout'; }
  var lastAdded = null, lastFocus = null;
  function trap(box, e) {
    if (e.key !== 'Tab') return;
    var f = box.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])'); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  function start(fn) { if (window.Theme && window.Theme.events) fn(); else document.addEventListener('DOMContentLoaded', function () { if (window.Theme) fn(); }); }

  var D = document, H = D.documentElement, A = 'addEventListener', R = 'removeEventListener';
  H.classList.add('hw-js');
  function still() { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function phone() { return window.matchMedia ? matchMedia('(max-width: 749px)') : { matches: false }; }
  function def(n, c) { if (!customElements.get(n)) customElements.define(n, c); }
  function raf(fn) { var q = 0; return function () { if (q) return; q = requestAnimationFrame(function () { q = 0; fn(); }); }; }
  function keep(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { /* private mode: the toggle still works for this visit */ } return null; }
  function paused() { return H.hasAttribute('data-hw-pause'); }
  function clamp(x, a, b) { return Math.max(a, Math.min(b, x)); }
  function live(end) {   /* a store-event end date (YYYY-MM-DD) has not passed in the visitor's time zone (event-code.js hides the same elements) */
    var e = String(end || '').replace(/-/g, ''); if (e.length !== 8) return true;
    var d = new Date(), p = function (n) { return n < 10 ? '0' + n : '' + n; };
    return ('' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate())) <= e;
  }

  /* ------------------------------------------------------------------ <hw-reveal> */
  def('hw-reveal', class extends HTMLElement {
    connectedCallback() {
      var s = this;
      if (!('IntersectionObserver' in window)) { s.classList.add('is-in'); return; }
      this.io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { s.classList.add('is-in'); s.io.disconnect(); } }, { rootMargin: '0px 0px -8% 0px' });
      this.io.observe(this);
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); }
  });

  /* ------------------------------------------------------------------ <hw-crop>: one scroll listener for every photo crop on the page */
  var crops = [], cropTick = raf(cropsUpdate);
  function cropsUpdate() {
    var vh = window.innerHeight || 800, off = still() || paused();
    crops.forEach(function (c) {
      if (!c._vis) return;
      var r = c.getBoundingClientRect(), p = off ? 0 : clamp(((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2), -1, 1);
      p = Math.round(p * 1000) / 1000;
      if (p !== c._p) { c._p = p; c.style.setProperty('--hw-p', p); }
    });
  }
  def('hw-crop', class extends HTMLElement {
    connectedCallback() {
      var s = this; this._vis = !('IntersectionObserver' in window); this._p = null;
      if (!crops.length) { window[A]('scroll', cropTick, { passive: true }); window[A]('resize', cropTick, { passive: true }); }
      crops.push(this);
      if ('IntersectionObserver' in window) { this._io = new IntersectionObserver(function (es) { s._vis = es[0].isIntersecting; if (s._vis) cropTick(); }, { rootMargin: '60px 0px' }); this._io.observe(this); }
      cropTick();
    }
    disconnectedCallback() {
      var i = crops.indexOf(this); if (i > -1) crops.splice(i, 1);
      if (this._io) this._io.disconnect();
      if (!crops.length) { window[R]('scroll', cropTick); window[R]('resize', cropTick); }
    }
  });

  /* ------------------------------------------------------------------ <hw-hero>: the Pause motion toggle, the loops */
  def('hw-hero', class extends HTMLElement {
    connectedCallback() {
      var s = this, b = this.querySelector('[data-hw-pausebtn]');
      function mark(v) { H.toggleAttribute('data-hw-pause', v); if (b) b.setAttribute('aria-pressed', v ? 'true' : 'false'); }
      mark(keep('hw-pause') === '1');
      this.tog = function () { var v = !paused(); mark(v); keep('hw-pause', v ? '1' : '0'); cropTick(); };
      if (b) b[A]('click', this.tog);
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('is-away', !e.isIntersecting); }); });
        [].forEach.call(this.querySelectorAll('.hw-loop'), function (l) { s.io.observe(l); });
      }
      /* the masthead is set as wide as the cover whatever font is showing: measured at 100px, then scaled (the CSS size is only the first guess) */
      var t = this.querySelector('.hw-mast__title'), w = t && t.querySelector('.hw-mast__word');
      this.fit = raf(function () {
        if (!w) return;
        t.style.fontSize = '100px';
        var k = w.getBoundingClientRect().width / 100 + 0.05, avail = t.clientWidth;
        if (k > 0.1 && avail > 40) t.style.fontSize = Math.floor(Math.min(window.innerWidth >= 750 ? 150 : 104, avail / k) * 10) / 10 + 'px';
      });
      if (w) { this.fit(); window[A]('resize', this.fit, { passive: true }); window[A]('load', this.fit); if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.fit); }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); window[R]('resize', this.fit); window[R]('load', this.fit); }
  });

  /* ------------------------------------------------------------------ <hw-pay>: WHAT YOU PAY */
  def('hw-pay', class extends HTMLElement {
    connectedCallback() {
      var s = this, q = this.querySelector('[data-pay-qty]'); if (!q) return;
      var unit = +this.dataset.price || 0, cut = +this.dataset.amount || 0, max = +this.dataset.max || 10, row = this.querySelector('[data-code-row]');
      function set(k, t) { var e = s.querySelector('[data-' + k + ']'); if (e && e.textContent !== t) e.textContent = t; }
      this.upd = function () {
        var n = clamp(parseInt(q.value, 10) || 1, 1, max), on = !!row && !row.hidden, sub = unit * n, off = on ? Math.min(cut, sub) : 0;
        set('q', String(n)); set('sub', money(sub)); if (row) set('off', '−' + money(cut)); set('total', money(sub - off));
      };
      this.tick = function () { setTimeout(s.upd, 0); };
      this[A]('input', this.upd); this[A]('change', this.upd); this[A]('click', this.tick);
      if (row && window.MutationObserver) { this._mo = new MutationObserver(this.upd); this._mo.observe(row, { attributes: true, attributeFilter: ['hidden'] }); }
      this.upd();
    }
    disconnectedCallback() { if (this._mo) this._mo.disconnect(); }
  });

  /* ------------------------------------------------------------------ <hw-eta>: Order today, estimated delivery Tue, Oct 13 - Fri, Oct 16 */
  def('hw-eta', class extends HTMLElement {
    connectedCallback() {
      var v = this.querySelector('[data-eta]'); if (!v) return;
      function add(n) { var d = new Date(), w; while (n > 0) { d.setDate(d.getDate() + 1); w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; }
      try {
        var f = { weekday: 'short', month: 'short', day: 'numeric' };
        v.textContent = add(7).toLocaleDateString('en-US', f) + ' – ' + add(10).toLocaleDateString('en-US', f);
        this.setAttribute('data-ready', '');
      } catch (e) { /* the written fallback stays */ }
    }
  });

  /* ------------------------------------------------------------------ <hw-pill>: the sticky buy pill on phones */
  def('hw-pill', class extends HTMLElement {
    connectedCallback() {
      var s = this, t = D.querySelector('[data-hw-hero-add]');
      if (!t || !('IntersectionObserver' in window)) return;
      H.classList.add('hw-has-pill');
      this.past = false; this.on = {};
      var ends = [].slice.call(D.querySelectorAll('.site-footer, .hw-final'));
      this.io = new IntersectionObserver(function (es) { es.forEach(function (e) { s.past = !e.isIntersecting && e.boundingClientRect.top < 0; }); s.apply(); });
      this.io.observe(t);
      this.io2 = new IntersectionObserver(function (es) { es.forEach(function (e) { s.on[ends.indexOf(e.target)] = e.isIntersecting; }); s.apply(); });
      ends.forEach(function (e) { s.io2.observe(e); });
    }
    apply() {
      var end = Object.keys(this.on).some(function (k) { return this.on[k]; }, this), on = this.past && !end;
      this.classList.toggle('is-in', on);
      if (on) { this.removeAttribute('aria-hidden'); this.removeAttribute('inert'); } else { this.setAttribute('aria-hidden', 'true'); this.setAttribute('inert', ''); }
    }
    disconnectedCallback() { if (this.io) this.io.disconnect(); if (this.io2) this.io2.disconnect(); H.classList.remove('hw-has-pill'); }
  });

  /* ------------------------------------------------------------------ <hw-spy>: in-page anchors, smooth scroll, "current" chip */
  function anchorId(a) {
    var h = a.getAttribute('href') || '', i = h.lastIndexOf('#');
    if (i < 0 || i === h.length - 1) return '';
    var id = h.slice(i + 1), base = h.slice(0, i).replace(/^#/, '');
    if (!id || id.charAt(0) === '/') return '';
    if (base && base !== '/' && base !== location.pathname) return '';
    return id;
  }
  def('hw-spy', class extends HTMLElement {
    connectedCallback() {
      var s = this, hero = D.querySelector('.hw-hero'); this._on = {}; this._cur = '';
      this._click = function (e) {
        if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest ? e.target.closest('a[href]') : null, id = a && anchorId(a), t = id && D.getElementById(id); if (!t || t.hidden) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: still() ? 'auto' : 'smooth', block: 'start' });
        try { history.replaceState(null, '', '#' + id); } catch (x) { /* the page still scrolled */ }
        if (!t.hasAttribute('tabindex')) t.setAttribute('tabindex', '-1');
        try { t.focus({ preventScroll: true }); } catch (x) { /* old browsers */ }
      };
      D[A]('click', this._click);
      this.links = [];
      [].forEach.call(D.querySelectorAll('.hw-chip'), function (a) { var id = anchorId(a), el = id && D.getElementById(id); if (el) s.links.push({ a: a, id: id, el: el }); });
      if (!this.links.length || !('IntersectionObserver' in window)) return;
      var vh = window.innerHeight;
      this._io = new IntersectionObserver(function (es) {
        es.forEach(function (en) { s._on[en.target.id] = en.isIntersecting; });
        var cur = ''; s.links.forEach(function (l) { if (s._on[l.id]) cur = l.id; });
        if (!cur && s._cur && window.pageYOffset > 40 && !(hero && s._on[hero.id])) cur = s._cur;   /* between two spreads keep the last one; back on the cover: none */
        s._cur = cur;
        s.links.forEach(function (l) { var on = l.id === cur; l.a.classList.toggle('is-current', on); if (on) l.a.setAttribute('aria-current', 'location'); else if (l.a.getAttribute('aria-current') === 'location') l.a.removeAttribute('aria-current'); });
      }, { rootMargin: '-' + Math.round(vh * 0.2) + 'px 0px -' + Math.round(vh * 0.5) + 'px 0px' });
      this.links.forEach(function (l) { s._io.observe(l.el); });
      if (hero) this._io.observe(hero);
    }
    disconnectedCallback() { D[R]('click', this._click); if (this._io) this._io.disconnect(); }
  });

  /* ------------------------------------------------------------------ the mini cart: an order form, bottom sheet (phone) / drawer (desktop) */
  var el = null, busy = false;
  var SVG = { x: '<path d="M6 6l12 12M18 6 6 18"/>', check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>', truck: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3.2v2.8h-7"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
              lock: '<rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5"/>' };
  function icon(n, z) { return '<svg width="' + (z || 18) + '" height="' + (z || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + SVG[n] + '</svg>'; }
  function build() {
    if (el && D.body.contains(el)) return el;
    var W = words(), P = PX + '-ui';
    el = D.createElement('div'); el.className = P; el.setAttribute('aria-hidden', 'true');
    el.innerHTML = '<div class="' + P + '__scrim" data-ui-close></div>' +
      '<aside class="' + P + '__panel" role="dialog" aria-modal="true" aria-labelledby="' + P + '-title" tabindex="-1"><div class="' + P + '__top">' +
      '<button type="button" class="' + P + '__grab" data-ui-close aria-label="' + esc(W.close) + '"><span></span></button>' +
      '<header class="' + P + '__head"><div class="' + P + '__ht"><p class="' + P + '__kick">' + esc(W.form) + '</p><h2 class="' + P + '__title" id="' + P + '-title">' + esc(W.title) + '</h2></div><span class="' + P + '__count"></span>' +
      '<button type="button" class="' + P + '__x" data-ui-close aria-label="' + esc(W.close) + '">' + icon('x') + '</button></header></div>' +
      '<p class="' + P + '__added" role="status" hidden>' + icon('check', 16) + '<span>' + esc(W.added) + '</span></p>' +
      '<div class="' + P + '__body"></div><footer class="' + P + '__foot"></footer></aside>';
    el[A]('click', function (e) {
      if (e.target.closest('[data-ui-close]')) { close(); return; }
      var b = e.target.closest('[data-ui-act]'); if (!b || busy) return;
      var act = b.getAttribute('data-ui-act'), n = Number(b.getAttribute('data-qty'));
      change(b.getAttribute('data-key'), act === 'remove' ? 0 : (act === 'plus' ? n + 1 : n - 1), act);
    });
    el[A]('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); close(); } trap(el, e); });
    drag(el);
    D.body.appendChild(el); return el;
  }
  function drag(root) {   /* swipe the handle or the header down to close the sheet (phones only) */
    var panel = root.querySelector('.' + PX + '-ui__panel'), y0 = null, dy = 0, t0 = 0, mq = phone();
    function down(e) { if (!mq.matches || e.target.closest('[data-ui-act], .' + PX + '-ui__x')) return; y0 = e.clientY; dy = 0; t0 = Date.now(); panel.classList.add('is-drag'); try { e.currentTarget.setPointerCapture(e.pointerId); } catch (x) { /* optional */ } }
    function move(e) { if (y0 === null) return; dy = Math.max(0, e.clientY - y0); panel.style.transform = 'translateY(' + dy + 'px)'; }
    function up() { if (y0 === null) return; var v = dy / Math.max(1, Date.now() - t0); y0 = null; panel.classList.remove('is-drag'); panel.style.transform = ''; if (dy > 110 || (dy > 40 && v > 0.6)) close(); }
    [root.querySelector('.' + PX + '-ui__grab'), root.querySelector('.' + PX + '-ui__head')].forEach(function (h) { h[A]('pointerdown', down); h[A]('pointermove', move); h[A]('pointerup', up); h[A]('pointercancel', up); });
  }
  function change(key, qty, act) {
    busy = true; el.classList.add('is-busy');
    T().cart.change(key, Math.max(0, qty)).then(function () { return render(key, act); }).catch(function () {}).then(function () { busy = false; el.classList.remove('is-busy'); });
  }
  function isGift(i) { return i.properties && i.properties._free_product === 'true'; }
  function render(refocusKey, refocusAct) {
    var W = words(), P = PX + '-ui';
    return T().cart.get().then(function (c) {
      var body = el.querySelector('.' + P + '__body'), foot = el.querySelector('.' + P + '__foot');
      var new0 = lastAdded && lastAdded.items && lastAdded.items[0] ? lastAdded.items[0].key : null;
      el.querySelector('.' + P + '__count').textContent = c.items.length ? count(c.item_count, W) : '';
      if (!c.items.length) {
        body.innerHTML = '<div class="' + P + '__empty"><p>' + esc(W.empty) + '</p><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc((T().routes && T().routes.all) || '/collections/all') + '" data-ui-close>' + esc(W.keep) + '</a></div>';
        foot.innerHTML = ''; foot.hidden = true; return;
      }
      foot.hidden = false;
      body.innerHTML = '<ul class="' + P + '__lines">' + c.items.map(function (i) {
        var v = i.variant_title && !/^default title$/i.test(i.variant_title) ? '<p class="' + P + '__meta">' + esc(i.variant_title) + '</p>' : '';
        var k = esc(i.key), ctl = isGift(i) ? '<span class="' + P + '__ro">× ' + i.quantity + '</span>' :
          '<div class="' + P + '__qty" role="group" aria-label="' + esc(W.qty) + '"><button type="button" data-ui-act="minus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.minus) + '">−</button>' +
          '<span aria-live="polite">' + i.quantity + '</span><button type="button" data-ui-act="plus" data-qty="' + i.quantity + '" data-key="' + k + '" aria-label="' + esc(W.plus) + '">+</button></div>' +
          '<button type="button" class="' + P + '__rm" data-ui-act="remove" data-qty="' + i.quantity + '" data-key="' + k + '">' + esc(W.remove) + '</button>';
        return '<li class="' + P + '__line' + (new0 && i.key === new0 ? ' is-new' : '') + '"><a class="' + P + '__pic" href="' + esc(i.url) + '" tabindex="-1" aria-hidden="true">' + pic(i.image, 80) + '</a>' +
          '<div class="' + P + '__info"><a class="' + P + '__name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a>' + v + '<div class="' + P + '__ctl">' + ctl + '</div></div>' +
          '<span class="' + P + '__price">' + money(i.final_line_price) + '</span></li>';
      }).join('') + '</ul>';
      /* the store-event coupon (the `cart` part of the shared snippet, in <template id="hw-ev-cart">; empty while the event is off) and, with it, the estimated total with the code */
      var tpl = D.getElementById(PX + '-ev-cart'), first = tpl && tpl.content && tpl.content.firstElementChild, end = first ? first.getAttribute('data-ev-end') : '';
      var cut = first && live(end) ? (+tpl.getAttribute('data-amount') || 0) : 0;
      if (first && live(end)) { var ev = D.createElement('div'); ev.className = P + '__ev'; ev.appendChild(tpl.content.cloneNode(true)); body.appendChild(ev); }
      var est = cut ? '<div class="' + P + '__row ' + P + '__row--code" data-ev-end="' + esc(end) + '"><span>' + esc(W.code_row) + ' ' + esc(tpl.getAttribute('data-code') || '') + '</span><span>−' + money(Math.min(cut, c.total_price)) + '</span></div>' +
        '<div class="' + P + '__row ' + P + '__row--est" data-ev-end="' + esc(end) + '"><span>' + esc(W.est) + '</span><strong>' + money(Math.max(0, c.total_price - cut)) + '</strong></div>' +
        '<p class="' + P + '__estnote" data-ev-end="' + esc(end) + '">' + esc(W.est_note) + '</p>' : '';
      foot.innerHTML = '<div class="' + P + '__row ' + P + '__row--sub"><span>' + esc(W.subtotal) + '</span><strong>' + money(c.total_price) + '</strong></div>' + est +
        '<hw-eta class="hw-eta hw-eta--line"><span class="hw-eta__ic" aria-hidden="true">' + icon('truck', 17) + '</span><span class="hw-eta__t"><span class="hw-eta__k">' + esc(W.eta) + '</span> <strong class="hw-eta__v" data-eta>' + esc(W.eta_fb) + '</strong></span></hw-eta>' +
        '<p class="' + P + '__ship">' + icon('truck') + '<span>' + esc(W.ship) + '</span></p>' +
        '<div class="' + P + '__acts"><a class="' + P + '__btn" href="' + esc(checkoutUrl()) + '">' + icon('lock') + '<span>' + esc(W.checkout) + '</span></a><a class="' + P + '__btn ' + P + '__btn--line" href="' + esc(cartUrl()) + '">' + esc(W.view_cart) + '</a></div>';
      if (refocusKey) {
        var again = el.querySelector('[data-key="' + refocusKey + '"][data-ui-act="' + refocusAct + '"]') || el.querySelector('[data-key="' + refocusKey + '"]') || el.querySelector('.' + P + '__x');
        if (again) again.focus();
      }
    });
  }
  function openUi(showAdded) {
    build(); lastFocus = D.activeElement;
    return render().then(function () {
      el.querySelector('.' + PX + '-ui__added').hidden = !showAdded;
      el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false'); H.style.overflow = 'hidden';
      var b = el.querySelector('.' + PX + '-ui__x');
      if (b && b.offsetParent) b.focus({ preventScroll: true }); else { var p = el.querySelector('.' + PX + '-ui__panel'); if (p) p.focus({ preventScroll: true }); }
    });
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true'); H.style.overflow = '';
    if (lastFocus && lastFocus.focus && D.contains(lastFocus)) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* focus is a courtesy */ } }
  }
  function afterAdd(after) {
    if (after === 'cart') return false;       /* the form asked for the cart page: let the theme go there */
    openUi(true).catch(function () {});
    return true;
  }
  function init() {
    D[A]('click', function (e) {
      if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var a = e.target.closest('.hw-top__cartlink'); if (!a) return;
      if (D.querySelector('boostly-cart-items')) return;   /* already on the cart page */
      e.preventDefault(); openUi(false).catch(function () {});
    });
    D[A]('keydown', function (e) { if (e.key === 'Escape' && el && el.classList.contains('is-open')) close(); });
  }

  start(function () {
    T().events.on('cart:added', function (e) { lastAdded = e.detail || null; });
    T().afterAddHook = function (after) { return afterAdd(after); };
    if (typeof init === 'function') init();
  });
})();

/* phone buy bar (<PX-mbar>) + cart checkout bar visibility */
(function () {
  'use strict';
  var PX = 'hw';
  function fmt(c) { try { return window.Theme.money.format(c); } catch (e) { return '$' + (Number(c || 0) / 100).toFixed(2); } }
  if (!customElements.get(PX + '-mbar')) customElements.define(PX + '-mbar', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = document.querySelector('.' + PX + '-pdp .product-form__submit');
      if (!this.main || !('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver(function (es) {
        var e = es[0]; self.show(!e.isIntersecting && e.boundingClientRect.top < 0);
      });
      this.io.observe(this.main);
      this.addEventListener('click', function (e) {
        if (!e.target.closest('[data-mbar-add]') || self.main.disabled) return;
        self.main.click();
      });
      this.onVariant = function (e) {
        var v = e.detail && e.detail.variant; if (!v) return;
        var p = self.querySelector('[data-mbar-price]'), b = self.querySelector('[data-mbar-add]');
        if (p) p.textContent = fmt(v.price);
        if (b) { b.disabled = !v.available; b.textContent = v.available ? self.dataset.add : self.dataset.sold; }
      };
      document.addEventListener('variant:change', this.onVariant);
    }
    show(on) { this.classList.toggle('is-in', on); document.documentElement.classList.toggle(PX + '-has-mbar', on); }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.onVariant) document.removeEventListener('variant:change', this.onVariant);
      document.documentElement.classList.remove(PX + '-has-mbar');
    }
  });
})();
